import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useTrans, useTrapKeyboardNavigation } from "../../../hooks";
import { Button, ButtonSize } from "@wattpad/web-ui-library";
import { Icon } from "../../../shared-components";

const APP_LINK = "https://read.w.tt/f4RR/eadd1193";
const SESSION_KEY = "mobile-prompt-dismissed";

const setPromptDismissed = () => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(SESSION_KEY, "1");
};

const shouldShowPrompt = () => {
  if (typeof window === "undefined") return;
  return !sessionStorage.getItem(SESSION_KEY);
};

// TODO: Once the Mobile Prompt Redesign is launced, remove "New" prefix and delete old MobileDownloadPrompt
const MobileDownloadPromptNew = () => {
  const { trans } = useTrans();
  const [isVisible, setIsVisible] = useState(false);
  const [drawerRef, setDrawerRef] = useState();
  const drawerRefCb = useCallback(
    ref => {
      setDrawerRef(ref);
    },
    [setDrawerRef]
  );
  useTrapKeyboardNavigation(drawerRef);

  useEffect(() => {
    if (shouldShowPrompt()) {
      document.body.classList.add("modal-open");
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    setPromptDismissed();
    setIsVisible(false);
    document.body.classList.remove("modal-open");
  };

  if (!isVisible) return null;
  return (
    <>
      <div
        className="modal-overlay"
        onClick={handleDismiss}
        role="presentation"
      />
      <div
        className={"new-mobile-download-prompt"}
        ref={drawerRefCb}
        aria-modal="true"
        role="dialog"
        aria-label="Dialog"
      >
        <Button
          size={ButtonSize.SMALL}
          href={APP_LINK}
          gtm="Download|bottom_banner|open_app"
          label={trans("Open")}
        />
        <div className={"title"}>
          <img
            src={"img/logos/Wattpad_Logomark_Orange_RGB.svg"}
            data-testid="wattpad-logo"
            alt={trans("Wattpad Logo")}
          />
          <span
            className={"mobile-download-prompt-logo-text"}
            data-testid="prompt-text"
          >
            {trans("View in Wattpad App")}
          </span>
        </div>
        <button className={"close-button"} name="close" onClick={handleDismiss}>
          <Icon name={"close"} size={24} />
        </button>
      </div>
    </>
  );
};

MobileDownloadPromptNew.propTypes = {
  onSendPromptEvent: PropTypes.func
};
export default MobileDownloadPromptNew;
